import "./footertablet.css";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import facebookIcon from "@/assets/facebook.png";
import instagramIcon from "@/assets/instagram.png";
import whatsappIcon from "@/assets/whatsapp.png";
import anpcSalSvg from "@/components/common/footer/anpc-sal.svg";
import anpcSolSvg from "@/components/common/footer/anpc-sol.svg";
import gdprEuSvg from "@/components/common/footer/gdpr.eu.svg";

interface FooterProps {
  logo: string;
  greenDot: string;
  NextButton: React.FC<any>;
  handleScrollToTop: () => void;
}

const FooterTablet: React.FC<FooterProps> = ({
  logo,
  greenDot,
  NextButton,
  handleScrollToTop,
}) => {
  return (
    <Container className="footer-container-mobile">
      <div className="mobile-footer-base">
        {/* Background image - keep for sizing */}
        <img className="mobile-footer-base-img" src="/footer/footer-base-tablet.webp" style={{ visibility: 'hidden' }} alt="" />
        
        {/* Green dots decoration */}
        <Col className="mobile-green-dots">
          <Row><img className="mobile-green-dot" src={greenDot} alt="" /></Row>
          <Row><img className="mobile-green-dot" src={greenDot} alt="" /></Row>
          <Row><img className="mobile-green-dot" src={greenDot} alt="" /></Row>
        </Col>
        
        {/* Scroll to top button */}
        <NextButton
          onClick={handleScrollToTop}
          className="mobile-footer-next"
        />
        
        {/* Main footer content */}
        <div className="mobile-footer">
          <div className="mobile-footer-row body">
            
            {/* Logo and description section - MOVE THIS RIGHT */}
            <Row className="mobile-footer-col mobile-footer-top-section">
              <Row>
                <div className="mobile-logo-row">
                  <img className="mobile-logo-footer" src={logo} alt="Pixado Logo" />
                </div>
              </Row>
              <Row>
                <p className="mobile-footer-text body mobile-logo-row">
                  Pixado este agenția ta de încredere pentru soluții creative de branding, web design & development, online marketing, reclame video și CGI/VFX. Cu un ochi atent pentru detalii și o echipă pasionată, transformăm ideile în realitate, livrând mereu rezultate memorabile.
                </p>
              </Row>
            </Row>
            
            {/* THREE COLUMNS IN ONE ROW - CENTERED */}
            <Row className="mobile-footer-links-section">
              <Col md={4} className="mobile-footer-col">
                <div className="mobile-footer-title title-4">Linkuri Rapide</div>
                
                <Row className="mobile-footer-option">
                  <Link to="/servicii/web-design" className="back-link">
                    Web Design
                  </Link>
                </Row>
                <Row className="mobile-footer-option">
                  <Link to="/servicii/e-commerce" className="back-link">
                    E-commerce
                  </Link>
                </Row>
                <Row className="mobile-footer-option">
                  <Link to="/servicii/branding" className="back-link">
                    Branding
                  </Link>
                </Row>
                <Row className="mobile-footer-option">
                  <Link to="/servicii/online-marketing" className="back-link">
                    Online Marketing
                  </Link>
                </Row>
              </Col>
              
              <Col md={4} className="mobile-footer-col">
                <div className="mobile-footer-title title-4">Linkuri Utile</div>
                <div className="mobile-footer-svg-container">
                  <div className="mobile-footer-svg-item">
                   <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer">                      
                    <img 
                        src={anpcSalSvg} 
                        alt="ANPC SAL" 
                        className="mobile-footer-svg"
                      />
                    </a>
                  </div>
                  <div className="mobile-footer-svg-item">
                    <a href="https://consumer-redress.ec.europa.eu/index_ro" target="_blank" rel="noopener noreferrer">
                      <img 
                        src={anpcSolSvg} 
                        alt="ANPC SOL" 
                        className="mobile-footer-svg"
                      />
                    </a>
                  </div>
                  <div className="mobile-footer-svg-item">
                    <a href="https://gdpr.eu/" target="_blank" rel="noopener noreferrer">
                      <img 
                        src={gdprEuSvg} 
                        alt="GDPR EU" 
                        className="mobile-footer-svg"
                      />
                    </a>
                  </div>
                </div>
              </Col>
              
              <Col md={4} className="mobile-footer-col">
                <div className="mobile-footer-title title-4">Contact</div>
                <div>Timișoara</div>
                <div>0745371620</div>
                <div>contact@pixado.ro</div>
              </Col>
            </Row>
            
            {/* Social Media Section - MOVED BELOW */}
            <Row className="mobile-footer-social-row">
              <Col xs={12}>
                <div className="mobile-footer-social-section">
                  <div className="mobile-footer-social-text body">Hai cu noi pe social media!</div>
                  <div className="mobile-footer-social-icons-container">
                    <a href="https://www.facebook.com/pixadoagency" target="_blank" rel="noopener noreferrer">
                      <img src={facebookIcon} className="mobile-contact-dot" alt="Facebook" />
                    </a>
                    <a href="https://www.instagram.com/pixadoagency/" target="_blank" rel="noopener noreferrer">
                      <img src={instagramIcon} className="mobile-contact-dot" alt="Instagram" />
                    </a>
                    <a href="https://wa.me/40745371620" target="_blank" rel="noopener noreferrer">
                      <img src={whatsappIcon} className="mobile-contact-dot" alt="WhatsApp" />
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
            
            {/* Center Text - KEEP IN PLACE */}
            <Row>
              <div className="mobile-footer-row-center title-1">
                <Row>AICI PENTRU TINE</Row>
              </div>
            </Row>
            
            {/* Bottom Legal Links - KEEP IN PLACE */}
            <Row className="mobile-footer-row-bottom body">
              <Col className="mobile-bottom-row-options-1" md={8}>
                <Row>website aflat in construcție</Row>
                <Row>© 2026 pixado agency</Row>
              </Col>
              <Col className="mobile-bottom-row-options-2" md={4}>
                <Row className="mobile-footer-option">
                  <Link to="/politica-confidentialitate" className="back-link" onClick={handleScrollToTop}>
                    Politica de confidențialitate
                  </Link>
                  </Row>
                  <Row className="mobile-footer-option">
                    <Link to="/termeni-conditii" className="back-link" onClick={handleScrollToTop}>
                      Termeni și condiții
                    </Link>
                  </Row>
                  <Row className="mobile-footer-option">
                    <Link to="/politica-cookies" className="back-link" onClick={handleScrollToTop}>
                      Politica de Cookies
                    </Link>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default FooterTablet;